import React from "react";
import New from "../assests/img/new.svg";
const Header = () => {
  return (
    <header className="site-header site-header-menu--right">
      <div className="container-fluid pr-lg--30 pl-lg--30">
        <nav className="navbar site-navbar offcanvas-active navbar-expand-lg navbar-light">
          <div className="brand-logo">
            <a href="/">
              <h2 className="gr-text-6 font-weight-bolder">
                <img style={{ height: "50px" }} src={New} alt="Brand" />
              </h2>
            </a>
          </div>
          <div className={"collapse navbar-collapse "} id="mobile-menu"></div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
